import * as React from "react";
import CustomFieldsView from "./CustomFieldsView";
import CustomField from "../../../model/customField/CustomField";
import {Dispatch} from "redux";
import {
	createPartnerBrandCustomField,
	fetchPartnerBrandCustomFields,
	updatePartnerBrandCustomField
} from "../../../store/action/customField/customField";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {RootState} from "../../../store/reducer/root/RootState";
import {Option} from "ts-option";
import {connect} from "react-redux";
import {OnFailure, OnSuccess, OnSuccessData} from "../../../store/action/actionHelpers";
import Toast from "../../helper/Toast";

interface IDispatchProps {
	/**
	 * Fetch partner brand custom fields method
	 */
	fetchPartnerBrandCustomFields: () => void;
	/**
	 * Create partner brand custom field.
	 * @param {CustomField} customField
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createPartnerBrandCustomField: (customField: CustomField,
		onSuccess: OnSuccessData<CustomField>,
		onFailure: OnFailure) => void;
	/**
	 * Update partner brand custom field.
	 * @param {CustomField} customField
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updatePartnerBrandCustomField: (customField: CustomField, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface ReduxProps {
	/**
	 * Partner Brand custom fields list.
	 */
	partnerBrandCustomFields: Option<CustomField[]>;
}

type Props = IDispatchProps & ReduxProps;

class PartnerBrandCustomFieldsView extends React.Component<Props> {
	render() {
		return (
			<CustomFieldsView customFields={this.props.partnerBrandCustomFields}
							  fetchCustomFields={this.props.fetchPartnerBrandCustomFields}
							  createCustomField={this.createPartnerBrandCustomField}
							  updateCustomField={this.updatePartnerBrandCustomField}
							  pageTitle={'Partner Brand custom fields'}
							  noDataText={'No Partner Brand custom fields'}/>
		);
	}

	createPartnerBrandCustomField = (customField: CustomField,
		onSuccess: OnSuccessData<CustomField>,
		onFailure: OnFailure) =>
		this.props.createPartnerBrandCustomField(customField,
			(customField) => {
				onSuccess(customField);
				Toast.success("Partner Brand custom field created", "Partner Brand custom field create");
			},
			(err) => {
				onFailure(err);
				notifyBugsnagAndShowToast(err, "Partner Brand custom field creation failed");
			}
		);

	updatePartnerBrandCustomField = (customField: CustomField,
		onSuccess: OnSuccess,
		onFailure: OnFailure) =>
		this.props.updatePartnerBrandCustomField(customField,
			() => {
				onSuccess();
				Toast.success("Partner Brand custom field updated", "Partner Brand custom field update");
			},
			(err) => {
				onFailure(err);
				notifyBugsnagAndShowToast(err, "Partner Brand custom field update failed");
			}
		);
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchPartnerBrandCustomFields: () => dispatch(
			fetchPartnerBrandCustomFields(() => {},
				(error) => notifyBugsnagAndShowToast(error, "Fetch Partner Brand custom fields"))
		),
		createPartnerBrandCustomField: (customField: CustomField,
			onSuccess: OnSuccessData<CustomField>,
			onFailure: OnFailure) => {
			dispatch(createPartnerBrandCustomField(customField, onSuccess, onFailure))
		},
		updatePartnerBrandCustomField: (customField: CustomField, onSuccess: OnSuccess, onFailure: OnFailure) => {
			dispatch(updatePartnerBrandCustomField(customField, onSuccess, onFailure))
		}
	};
}

function mapStateToProps(state: RootState) {
	return {
		partnerBrandCustomFields: state.customFields.partnerBrandCustomFields
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerBrandCustomFieldsView)